module.exports = __webpack_public_path__ + "assets/img/photo-1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/testimonials/photo-1.jpg
// module id = 1989
// module chunks = 0